import { BaseEntity, JsonApiResource } from '../jsonapi-provider';

@JsonApiResource({
  type: 'menu-type',
})
export default class MenuType extends BaseEntity {
  name: string = '';
  inputLayout: string = '';
}
